// Appels à l'API du serveur, en JSON, avec les cookies de session.
// Une seule fonction `api()` ; les erreurs deviennent des exceptions `ErreurApi` avec le message
// en français renvoyé par le serveur (R-GEN-02).
export class ErreurApi extends Error {
  constructor(public statut: number, message: string, public code?: string, public details?: unknown) {
    super(message);
  }
}

export async function api<T = unknown>(chemin: string, options: { methode?: 'GET' | 'POST' | 'PUT' | 'DELETE'; corps?: unknown; formulaire?: FormData; signal?: AbortSignal } = {}): Promise<T> {
  const entetes: Record<string, string> = { Accept: 'application/json' };
  let body: BodyInit | undefined;
  if (options.formulaire) body = options.formulaire;
  else if (options.corps !== undefined) { entetes['Content-Type'] = 'application/json'; body = JSON.stringify(options.corps); }
  const reponse = await fetch(chemin, { method: options.methode ?? (body ? 'POST' : 'GET'), headers: entetes, body, credentials: 'same-origin', signal: options.signal });
  if (reponse.status === 304) return undefined as T;
  const texte = await reponse.text();
  const donnees = texte ? (JSON.parse(texte) as Record<string, unknown>) : {};
  if (!reponse.ok) throw new ErreurApi(reponse.status, String(donnees['erreur'] ?? `Erreur ${reponse.status}`), donnees['code'] as string | undefined, donnees);
  return donnees as T;
}

/** Vrai si l'erreur vient d'une absence de réseau (et non d'un refus du serveur). */
export function estHorsLigne(erreur: unknown): boolean {
  return erreur instanceof TypeError || (typeof navigator !== 'undefined' && !navigator.onLine);
}
